/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseReviewItemFragment, ReviewItemFragment, FullReviewItemFragment} from '@amblique/contentful/app/contentful/fragments/review-item';

/**
 * Get a single ReviewItem by ID (base - scalars only)
 */
export const getBaseReviewItemById = gql`
  ${BaseReviewItemFragment}

  query GetBaseReviewItemById($id: String!, $locale: String!, $preview: Boolean) {
    reviewItem(id: $id, locale: $locale, preview: $preview) {
      ...BaseReviewItemFragment
    }
  }
`;

/**
 * Get a single ReviewItem by ID (standard - 1 level deep)
 */
export const getReviewItemById = gql`
  ${ReviewItemFragment}

  query GetReviewItemById($id: String!, $locale: String!, $preview: Boolean) {
    reviewItem(id: $id, locale: $locale, preview: $preview) {
      ...ReviewItemFragment
    }
  }
`;

/**
 * Get a single ReviewItem by ID (full - 2 levels deep)
 */
export const getFullReviewItemById = gql`
  ${FullReviewItemFragment}

  query GetFullReviewItemById($id: String!, $locale: String!, $preview: Boolean) {
    reviewItem(id: $id, locale: $locale, preview: $preview) {
      ...FullReviewItemFragment
    }
  }
`;

/**
 * Get all ReviewItem entries with pagination (base - scalars only)
 */
export const getBaseReviewItems = gql`
  ${BaseReviewItemFragment}

  query GetBaseReviewItems(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [ReviewItemOrder]
    $where: ReviewItemFilter
    $preview: Boolean
  ) {
    reviewItemCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseReviewItemFragment
      }
    }
  }
`;

/**
 * Get all ReviewItem entries with pagination (standard - 1 level deep)
 */
export const getReviewItems = gql`
  ${ReviewItemFragment}

  query GetReviewItems(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [ReviewItemOrder]
    $where: ReviewItemFilter
    $preview: Boolean
  ) {
    reviewItemCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...ReviewItemFragment
      }
    }
  }
`;

/**
 * Get all ReviewItem entries with pagination (full - 2 levels deep)
 */
export const getFullReviewItems = gql`
  ${FullReviewItemFragment}

  query GetFullReviewItems(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [ReviewItemOrder]
    $where: ReviewItemFilter
    $preview: Boolean
  ) {
    reviewItemCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullReviewItemFragment
      }
    }
  }
`;
